import React, { useState } from 'react';
import ImageGallerdastarkhawan from '../components/ImageGallerdastarkhawan';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCDASTAR = () => {
    const { stats, loading } = useStats();
    const [foodQuantity, setFoodQuantity] = useState(1);
    const foodBaseAmount = 50;

    // Format date for display
    const formatDisplayDate = (dateString) => {
        if (!dateString) return '31-Jan-2025';
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Format number with commas
    const formatNumber = (num) => {
        if (!num && num !== 0) return 'Loading...';
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // Food Distribution handlers
    const handleFoodIncrease = () => setFoodQuantity(prev => prev + 1);
    const handleFoodDecrease = () => setFoodQuantity(prev => prev > 1 ? prev - 1 : 1);
    const handleFoodQuantityChange = (e) => {
        const value = parseInt(e.target.value) || 1;
        setFoodQuantity(value > 0 ? value : 1);
    };

    const foodTotalAmount = foodQuantity * foodBaseAmount;

    if (loading) return <div className="loading">Loading statistics...</div>;

    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGallerdastarkhawan />

                    {/* IRC Dastarkhwan */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC DASTARKHWAN (FOOD FOR POOR & NEEDY)</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                The Prophet Muhammad said: "O people! Spread salam, provide food (to poor & needy), uphold the ties of kinship, and pray during the night when people are sleeping, and you will enter Jannah safely. (Ibn Majah 3251)
                            </p>
                            <p>
                                IRC DASTARKHWAN (FOOD FOR POOR & NEEDY) is a compassionate initiative by the Islamic Research Centre Education & Welfare Trust, dedicated to providing nutritious meals to Poor & needy. This program offers daily, quality meals to the underserved, creating a welcoming environment where all are treated with dignity and respect. With a mission to fight hunger and uplift the community. Join us in supporting this essential effort to ensure no one goes hungry in our community. Click here for Donation
                            </p>

                            <div className="clinic-card">
                                <p><strong>Name:</strong> IRC DASTARKHWAN (Free Food Distribution)</p>
                                <p><strong>Address:</strong> # 1-23-94 Rohila Gali Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                                <p>
                                    <strong>Location: </strong>
                                    <a href="https://www.google.com/maps/place/Masjid+Ikhlas/@19.8909525,75.3303293,76m/data=!3m1!1e3!4m6!3m5!1s0x3bdb99588c76a00f:0xcf1c49b4ae78975!8m2!3d19.8909467!4d75.330867!16s%2Fg%2F11vjm4_dll?authuser=0&entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=0c44c213-ab7e-4e64-90c9-de6e69bc03f3" target="_blank" rel="noopener noreferrer">
                                        📍Click here for Location
                                    </a>
                                </p>
                                <p><strong>Date of Inauguration:</strong> 13-Oct-2024</p>
                                <p><strong>No. of Beneficiary:</strong> {formatNumber(stats.dastarkhwan_beneficiaries)} (till {formatDisplayDate(stats.dastarkhwan_date)})</p>
                            </div>

                            <div className="cost-breakdown">
                                <h4>What Your Donation Provides</h4>
                                <div className="breakdown-grid">
                                    <div className="breakdown-item">
                                        <span className="breakdown-icon">🍚</span>
                                        <span className="breakdown-text">Nutritious Meal</span>
                                    </div>
                                    <div className="breakdown-item">
                                        <span className="breakdown-icon">🥗</span>
                                        <span className="breakdown-text">Balanced Diet</span>
                                    </div>
                                    <div className="breakdown-item">
                                        <span className="breakdown-icon">💧</span>
                                        <span className="breakdown-text">Clean Water</span>
                                    </div>
                                    <div className="breakdown-item">
                                        <span className="breakdown-icon">👨‍👩‍👧‍👦</span>
                                        <span className="breakdown-text">Family Support</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Food Distribution Donation Card */}
                        <IRCTVDonationCard
                            title="IRC DASTARKHWAN (FOOD FOR POOR & NEEDY)"
                            subtitle="Feed the Hungry, Earn Blessings"
                            description="Your donation provides nutritious meals to those in need. Every ₹50 feeds one person with a complete, balanced meal. Join us in following the Sunnah of feeding others."
                            baseAmount={foodBaseAmount}
                            quantity={foodQuantity}
                            onIncrease={handleFoodIncrease}
                            onDecrease={handleFoodDecrease}
                            onQuantityChange={handleFoodQuantityChange}
                            totalAmount={foodTotalAmount}
                            purpose={`Food for ${foodQuantity} person${foodQuantity > 1 ? 's' : ''}`}
                            behalf="Donation Options"
                            behalfdescription="Choose how many people you want to feed"
                            showQuantityControls={true}
                            serviceType="food"
                            buttonText="Donate for Food"
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCDASTAR;